export interface IUsernameAvailableResponse {
  successful: boolean;
  message: string;
  available: string;
}

export class UsernameAvailableResponse implements IUsernameAvailableResponse {
  successful: boolean;
  message: string;
  available: string;
}
